import React, { useState, useEffect } from 'react'
import { Form, Button, InputGroup } from "react-bootstrap"
import redirections from "../img/redirections.svg"
import ConfirmatoryModal from "../Components/ConfirmatoryModal";
import * as formik from 'formik';
import * as yup from 'yup';
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import { deleteRedirection, saveRedirection, isValidPublicUrl, handleSubmit, handleChange, getModalData } from "../Functions/myfunctions"
import { useNavigate } from 'react-router-dom';


function ModificationRedirection() {

    const { Formik } = formik;
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [modifiedData, setModifiedData] = useState([]);
    const [modalShow, setModalShow] = React.useState(false);
    const [actionName, setActionName] = useState({ name: '', action: '', values: '' });
    const [urlLink, setUrlLink] = useState();
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        serialNumber: "",
        publicUrl: "",
        privateUrl: "",
        partner: "",
        comment: "",
        active: "",
    })


    const location = useLocation();
    const { token } = useParams();

    const loadData = async () => {
        setLoading(true);

        axios.post(process.env.REACT_APP_BASE_URL + "/api/redirections/edit/" + token + "/?code=" + process.env.REACT_APP_API_KEY, {
            "sessionToken": sessionStorage.getItem("sessionToken")
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            console.log(res);
            console.log(res.data);
            setModifiedData(res.data);
        }).catch((error) => {
            if (error.response.data === "Access denied!") {
                sessionStorage.clear();
                window.location = "/";
            }

            if (error.response.data === "Redirection not found!") {
                setErrorMessage("Hiba történt! Az átirányítás nem található!");
            }
        });
        setLoading(false);
    }

    useEffect(() => {
        loadData();
    }, [])

    const ModificationRedirectionSchema = yup.object().shape({
        serialNumber: yup.string()
            .required('A gyáriszám kitöltése kötelező'),
        publicUrl: yup.string()
            .test("Az url valid", "Az url nem valid", (value) => {
                return isValidPublicUrl(value);
            })
            .required('A publikus url kitöltése kötelező'),
        privateUrl: yup.string()
            .url("Érvénytelen url")
            .required('A privát url kitöltése kötelező'),
        active: yup.string()
            .required('Státusz választása kötelező'),
        comment: yup.string()
            .max(100, 'A megjegyzés maximum 100 karakter hosszú lehet.')
    });

    const save = (values, actions) => {
        getModalData({ name: 'Kívánja a módosítást végrehajtani?', action: 'save', values: values }, "", modalShow, setActionName, setUrlLink, setModalShow);
    }


    const confirmationfunction = (event) => {
        event.preventDefault();
        const dataCopy = { ...actionName.values };
        dataCopy["userId"] = sessionStorage.getItem("loggedUserId");
        dataCopy["sessionToken"] = sessionStorage.getItem("sessionToken");
        dataCopy["RowId"] = token;
        if (actionName.action === "save") {
            saveRedirection(dataCopy, setErrorMessage);
        }

        setModalShow(false);
    }

    const navigate = useNavigate();

    const navigateToRedirections = () => {
        // 👇️ navigate to /redirections
        navigate('/redirections');
    };


    return (
        <div className="form-page-content">
            <div className='custom-title'><img src={redirections} alt="redirection-icon" /><h1>Átirányítás módosítása</h1></div><br />
            <Formik initialValues={{
                serialNumber: modifiedData.SerialNumber,
                publicUrl: modifiedData.PublicUrl,
                privateUrl: modifiedData.PrivateUrl,
                partner: modifiedData.Partner,
                comment: modifiedData.Comment,
                active: modifiedData.Active,
            }}
                enableReinitialize={true}
                validationSchema={ModificationRedirectionSchema}
                onSubmit={(values, actions) => {
                    save(values, actions);
                }}
            >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="SerialNumber">
                            <Form.Label >
                                Gyári szám*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control placeholder="Gyári szám" type="text" name="serialNumber" required value={values.serialNumber} onChange={handleChange} isInvalid={!!errors.serialNumber} readOnly={true} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.serialNumber}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="PublicUrl">
                            <Form.Label >
                                Publikus URL*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control placeholder="Publikus URL" type="text" name="publicUrl" required value={values.publicUrl} onChange={handleChange} isInvalid={!!errors.publicUrl} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.publicUrl}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="PrivateUrl">
                            <Form.Label >
                                Privát URL*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control placeholder="Privát URL" type="text" name="privateUrl" required value={values.privateUrl} onChange={handleChange} isInvalid={!!errors.privateUrl} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.privateUrl}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Partner">
                            <Form.Label>
                                Partner
                            </Form.Label>
                            <InputGroup >
                                <Form.Control placeholder="Partner" type="text" name="partner" required value={values.partner} onChange={handleChange} />
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="Comment">
                            <Form.Label>Megjegyzés</Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control as="textarea" placeholder='Megjegyzés' name="comment" required value={values.comment} onChange={handleChange} isInvalid={!!errors.comment} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.comment}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="active">
                            <InputGroup hasValidation>
                                <Form.Label>Státusz*</Form.Label>
                                <Form.Select aria-label="active select " value={values.active} onChange={handleChange} isInvalid={!!errors.active}>
                                    <option disabled>Státusz</option>
                                    <option value="1">Aktív</option>
                                    <option value="0">Inaktív</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.active}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3 form-buttons">
                            <Button type="submit" className="form-custom-button">Mentés</Button><Button type="button" onClick={navigateToRedirections} className='form-delete-button'>Mégsem</Button>
                        </Form.Group>
                        {errorMessage !== "" ? <p className="error mb-3">{errorMessage}</p> : ""}
                    </Form>
                )}
            </Formik>
            <ConfirmatoryModal actionname={actionName} urllink={urlLink} confirmationfunction={confirmationfunction}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div >
    )
}

export default ModificationRedirection;